import { Button, Card } from "../primitives";
import { useTranslation } from "../../hooks/useTranslation";
import { useState } from "react";

export default function Resubscribe({ onConfirm, onCancel, totalCost }) {
    const t = useTranslation();
    const [loading, setLoading] = useState(false);

    async function handleResubscribe() {
        setLoading(true);
        await onConfirm();
        setLoading(false);
    }

    return (
        <Card className='white'>
            <Card.Header>
                <h2>{t('Resubscribe')}</h2>
            </Card.Header>
            <Card.Body>
                <p>{t('Are you sure you want to resubscribe to your subscription?')}</p>
                <Button onClick={handleResubscribe} loading={loading} className='submit'>{t('Resubscribe')}: {totalCost}</Button>
                <Button onClick={onCancel} disabled={loading}>{t('Cancel')}</Button>
            </Card.Body>
        </Card>
    )
}
